export const branchOfficesPage1 = {
  message: 'OK.',
  data: [
    {
      id: '1',
      label: 'Weppa'
    },
    {
      id: '7',
      label: 'Habana'
    }
  ]
}

export const branchOfficeUsersPage1 = {
  message: 'OK',
  data: {
    results: [
      {
        id: 45,
        email: 'jperez@weppa.com',
        phone: '04141234567',
        name: 'Juan',
        lastName: 'Pérez',
        isEnabled: true,
        isLocked: false,
        allowsAccessRentability: false,
        photo: null,
        branchOfficeName: 'Pc4shop Galerias Avila',
        roles: ['Vendedor']
      },
      {
        id: 46,
        email: 'mgomez@weppa.com',
        phone: '04241239876',
        name: 'María',
        lastName: 'Gómez',
        isEnabled: true,
        isLocked: false,
        allowsAccessRentability: false,
        photo: null,
        branchOfficeName: 'Pc4shop Galerias Avila',
        roles: ['Vendedor', 'Supervisor']
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 2,
      range: [1],
      count: 2,
      pages: 1,
      total: 2,
      limit: 20
    }
  },
  status: 200
}
